import { useContext } from "react";

import { BoardRunsContext, IBoardRunsContext } from "./BoardRunsContext";

export function useBoardRuns(): IBoardRunsContext {
  const context = useContext(BoardRunsContext);
  if (!context) {
    throw new Error("useBoardRuns must be used within a BoardRunsProvider");
  }

  return context;
}
